import { getSavedState, saveState } from './helpers.js';

export default {
    namespaced: true, // important pour éviter les conflits avec d'autres modules

    state: () => ({
        topbarMenu: getSavedState('topbarMenu') || "home",
    }),

    getters: {
        topbarMenu(state) {
            return state.topbarMenu;
        },
    },

    mutations: {
        SET_TOPBAR_MENU(state, newValue) {
            state.topbarMenu = newValue;
            saveState('topbarMenu', newValue);
        },
    },

    actions: {
        setTopbarMenu({ commit }, newValue) {
            commit('SET_TOPBAR_MENU', newValue);
        },
    },
};